// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__KBrPM","alertIcon":"ConfirmModal_alertIcon__26hJh"};